// extracted by mini-css-extract-plugin
module.exports = {"customerNavigationOpen":"MyAccountMenu_customerNavigationOpen__15OTM","redirectionMenu":"MyAccountMenu_redirectionMenu__3UOmp"};